import React, { useEffect, useState } from 'react'
import Slider from "react-slick";
import styled from 'styled-components';
import HeaderItem from './HeaderItem';

const Header = ({ projectsData }) => {

    const [data, setData] = useState(null)

    useEffect(() => {
        setData(projectsData)
    }, [])

    const settings = {
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        swipeToSlide: true,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        fade: true,
        autoplaySpeed: 3000,
        cssEase: "linear"
    };

    return (
        <Head>
            <Slider {...settings}>
                {
                    data ? data.map((data) => <HeaderItem data={data} key={data.id} />) : <h1>LOADING...</h1>
                }
            </Slider>
        </Head>
    )
}

const Head = styled.div`
    overflow-x: hidden;
`;

export default Header
